(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-logo-row]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var track = section.querySelector('[data-logo-track]');
      if (!track) return;

      var speedAttr = section.getAttribute('data-scroll-speed');
      var speed = parseInt(speedAttr, 10);
      if (isNaN(speed) || speed <= 0) speed = 40; // px/sec default

      var viewport = section.querySelector('.logo-row');
      if (!viewport) return;

      // Width of one full logo set (we duplicated it in Liquid)
      var totalWidth = track.scrollWidth / 2;
      var viewportWidth = viewport.clientWidth;

      // Only auto-scroll if content is wider than viewport
      if (totalWidth <= viewportWidth) {
        track.style.animation = 'none';
        return;
      }

      // Scroll distance = negative width of one logo set
      track.style.setProperty('--scroll-distance', '-' + totalWidth + 'px');

      // Duration (seconds) = distance / speed
      var duration = totalWidth / speed;
      track.style.animationDuration = duration + 's';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
